import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";

import { GeneralService } from './general.service';
import { MessageService } from 'primeng/components/common/messageservice';
import { PersistenceService } from 'angular-persistence';
import { environment } from '../../environments/environment';
import { Customer } from '../models/customer.model';

@Injectable()
export class CustomerService extends GeneralService {
  constructor(protected messageService: MessageService, protected httpClient: HttpClient, protected persistenceService: PersistenceService) {
    super(messageService, httpClient, persistenceService, environment.apiCRMUrl, "customer");
  }
  
 
  async getAllAsync(): Promise<any> {
    const res = await this.getAll().toPromise();
    if (!this.isValidResponse(res)) return;
    const data = res.data as Customer[];
    return data;
  }

}


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_core_angular/src/app/services/customer.service.ts